import * as React from 'react';
import { SvgIcon } from '@material-ui/core';

const Warning = props => {
  return (
    <SvgIcon {...props} width="17.024" height="14.411" viewBox="0 0 17.024 14.411">
      <g transform="translate(-8.916 -47.205)">
        <g transform="translate(8.916 47.205)">
          <g transform="translate(0 0)">
            <path
              fill="#eb6c25"
              d="M24.861,61.1H10.229a1.6,1.6,0,0,1-.362-.017.588.588,0,0,1-.424-.645.782.782,0,0,1,.152-.314c.221-.362.445-.724.666-1.09q1.568-2.561,3.135-5.126,1.531-2.509,3.066-5.015c.193-.317.39-.635.583-.952a1.1,1.1,0,0,1,.179-.2c.007-.007.055-.031.034-.024s-.1-.031-.028.01a.535.535,0,0,1,.152.166c.014.021.028.041.041.066.093.145.186.29.279.431q1.438,2.235,2.88,4.467l3.484,5.4q.512.8,1.028,1.594l.193.3a.7.7,0,0,1,.141.455.574.574,0,0,1-.569.5.259.259,0,0,0,0,.517,1.1,1.1,0,0,0,.973-1.576,2.556,2.556,0,0,0-.21-.331c-.314-.486-.628-.976-.945-1.462l-3.425-5.308q-1.5-2.328-3-4.653c-.114-.172-.224-.348-.338-.521a1.263,1.263,0,0,0-.483-.514c-.548-.245-.924.579-1.162.966q-1.412,2.308-2.821,4.615-1.65,2.7-3.3,5.4c-.3.493-.6.986-.907,1.48a3.7,3.7,0,0,0-.245.421A1.1,1.1,0,0,0,10,61.616H24.847A.259.259,0,0,0,24.861,61.1Z"
              transform="translate(-8.916 -47.205)"
            />
          </g>
        </g>
        <g transform="translate(16.149 50.412)">
          <g transform="translate(0 0)">
            <path
              fill="#eb6c25"
              d="M219.945,146.148q-.4-2.385-.8-4.774a.574.574,0,0,1,.911-.569c.286.235.2.548.152.855q-.254,1.5-.5,3c-.083.5-.166.993-.252,1.49-.055.328.445.466.5.138q.4-2.385.8-4.774a1.22,1.22,0,0,0-.024-.6,1.084,1.084,0,0,0-2.09.559l.4,2.4c.135.807.272,1.611.407,2.418C219.5,146.614,220,146.476,219.945,146.148Z"
              transform="translate(-218.622 -140.17)"
            />
          </g>
        </g>
        <g transform="translate(16.041 57)">
          <path
            fill="#eb6c25"
            d="M216.015,332.372a.666.666,0,1,1,.666.666.675.675,0,0,1-.666-.666.259.259,0,0,0-.517,0,1.183,1.183,0,1,0,1.183-1.183,1.2,1.2,0,0,0-1.183,1.183A.259.259,0,0,0,216.015,332.372Z"
            transform="translate(-215.498 -331.189)"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export default Warning;
